import InputBase from "@material-ui/core/InputBase";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { FieldProps } from "formik";
import React from "react";

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  })
)(InputBase);

export interface Item {
  value: any;
  description: string | number;
}

interface Props {
  items: Item[];
  none?: boolean;
  value?: any;
}

const Dropdown: React.FC<Props & FieldProps> = ({
  value,
  field,
  form,
  items,
  none,
  ...props
}) => {
  // console.log(items);
  return (
    <Select
      input={
        <BootstrapInput
          name="dropdown"
          id="age-customized-select"
          {...field}
          {...props}
        />
      }
    >
      {none && (
        <MenuItem value={0}>
          <em>none</em>
        </MenuItem>
      )}
      {items.map((item: Item) => (
        <MenuItem
          key={item.value}
          value={item.value}
          selected={item.value === value}
        >
          {item.description}
        </MenuItem>
      ))}
    </Select>
  );
};

export default Dropdown;
